<template>
  <div class="global__alert">
    <b-modal size="lg" hide-footer id="createGlobalAlert" title="Create alert" class="modal-create-global-alert" @hide="closeAlertDetail">
        <CreateGlobalAlert ref="refCreateGlobalAlert"/>
    </b-modal>
    <b-modal v-model="confirmDeleteAlert" type="warn" title="Confirm Deletion" @ok="deleteAlert(deleteAlertId)" ok-title="Yes, Delete">
        <p>Are you sure you want to delete this alert?</p>
    </b-modal>
    <b-modal size="lg" hide-footer id="globalAlertDetail1" class="modal-global-alert-detail" @hide="closeAlertDetail">
        <template slot='modal-title'>
            {{alertTitle}}
            <p class="notification-sender">
            sent by {{ alertSender }} @ {{ getLocalAlertTime(alertTime) }}
            </p>
        </template>
        <span v-html="alertDetail"></span>
    </b-modal>
    <b-modal size="lg" hide-footer id="alertStatusDetail" title="Alert Status Log" class="modal-alert-status-detail" @hide="closeAlertDetail">
        <table class="table table-striped table-bordered table-hover">
            <thead>
                <tr>
                    <th>User</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(alertStatus, index) in alertStatusDetail" :key="index">
                    <td>{{ alertStatus.name }}</td>
                    <td>
                        <span v-if="alertStatus.status == 1" class="badge badge-primary">Read</span>
                        <span v-if="alertStatus.status == 0" class="badge badge-danger">Unread</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </b-modal>
    <HeaderControls @createNewAlert="createAlert"  :namespace="namespace"/>
    <div class="fixed-top-bar-padding">
        <div class="container-fluid">
            <div class="deliverable-header">
                <h2>
                    <div @click="createAlert" class="media-call-icon">
                        <img width="30px" src="@/csmworkflow/img/bell-module.svg"/>
                        <span class="add-media-call-icon">
                            <img src="@/csmworkflow/img/add-icon.svg"/>
                        </span>
                    </div>
                    Global Alert
                </h2>
            </div>
        </div>

        <div class="container-fluid">
            <div class="global-alerts-status">
                <span v-if="typeof allAlerts.data != 'undefined' && allAlerts.data.length == 0"><h2>There are no alerts at the moment.</h2></span>
                <div class="alert-item clearfix">
                    <ul v-if="typeof allAlerts.data != 'undefined' && allAlerts.data.length > 0" class="list-unstyled">
                        <li
                        :id="`alert-row-${alert.id}`"
                        :key="'alert-'+index"
                        v-for="(alert,index) in allAlerts.data"
                        @click="setAlert(alert)"
                        class="cursor-pointer"
                        >
                            <div>
                                <span class="info-bubbles">
                                <span class="initials badge badge-primary cursor-pointer">
                                    {{ alert.sender | textInitials }}
                                </span>
                                </span>
                                <span @click.stop="confirmDeleteAlert=true; deleteAlertId = alert.id;" class="remove-alert cursor-pointer">
                                    <i class="fas fa-trash"></i>
                                </span>
                                <span @click.stop="showStatusDetail(alert)" class="alert-detail cursor-pointer">
                                    <i class="fas fa-info"></i>
                                </span>
                                <p class="details">
                                    <span class="alert__name cursor-pointer fw-bold">{{ alert.title }}</span>
                                    <br>
                                    <span class="notification-sender">
                                        <span class="fw-bold">{{ alert.sender }} @ {{ getLocalAlertTime(alert.created_at) }}</span>
                                    </span>
                                    <br>
                                    <span class="note-message" v-html="processMessage(alert.message)"></span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- <table class="table table-striped table-bordered table-hover" v-if="typeof allAlerts.data != 'undefined' && allAlerts.data.length > 0">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Message</th>
                            <th>Sent</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :key="'alert-'+index" v-for="(alert,index) in allAlerts.data" @click="seltAlert(alert)" class="cursor-pointer">
                            <td class="position-relative">
                                <span>
                                    {{ alert.title }}
                                </span>
                                <span v-b-tooltip.hover title="Delete alert" class="cursor-pointer delete-alert" @click.stop="deleteAlert(alert.id)">
                                    <img src="@/csmworkflow/img/popup-minus.png"/>
                                </span>
                            </td>
                            <td>
                                <span class="truncate-text">
                                    {{ alert.message }}
                                </span>
                            </td>
                            <td>
                                {{ alert.created_at | moment('MMM DD @ HH:mm') }}
                            </td>
                            <td>
                                <a href="#" @click.stop="showStatusDetail(alert)">
                                    Detail
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table> -->
                <div class="pagination-wrapper">
                    <pagination :data="allAlerts" @pagination-change-page="onChangePage" :limit="5"></pagination>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import HeaderControls from "../components/common/HeaderControls";
import CreateGlobalAlert from "../components/common/CreateGlobalAlert";
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
        	namespace:"",
            pendingScrollAlertId: null,
            alertTitle: '',
            alertDetail: '',
            alertTime: '',
            alertSender: '',
            confirmDeleteAlert: false,
            deleteAlertId: '',
            alertStatusDetail: [],
            currentAlertId: null,
            isShowingStatus: false,
            openedDirectlyWithModal: false
        }
    },
    components: {
        HeaderControls,
        CreateGlobalAlert
    },
    computed: {
        ...mapGetters(['allAlerts']),
    },
    created() {
        const path = window.location.pathname;
        const isModalUrl = /\/global-alert\/(new\/)?(\d+|new)/.test(path);
        const navEntries = performance.getEntriesByType('navigation');
        const navigationType = navEntries.length > 0 ? navEntries[0].type : 'navigate';
        const isReload = navigationType === 'reload';
        if (isModalUrl && !document.referrer && !isReload) {
            this.openedDirectlyWithModal = true;
        }
    },
    mounted() {
        const routeName = this.$route.name;
        const alertId = this.$route.params.alertId;
        const isDirectAlertAccess = ['globalAlertDetail', 'globalAlertStatus', 'globalAlertNew'].includes(routeName) && alertId;
        
        if (isDirectAlertAccess) {
            const lastPage = parseInt(sessionStorage.getItem('globalAlertLastPage')) || 1;
            this.fetchAlerts(lastPage);
            document.title = `Global Alert`;
            
            if (alertId !== 'new') {
                this.loadAndShowAlert(alertId, routeName);
            } else {
                this.handleRouteParams();
            }
        } else {
            const pageFromUrl = parseInt(this.$router.currentRoute.query.page) || 1;
            this.fetchAlerts(pageFromUrl);
            document.title = `Global Alert - Page ${pageFromUrl}`;
            sessionStorage.setItem('globalAlertLastPage', pageFromUrl);
        }
    },
    methods: {
        ...mapActions(['fetchAlerts']),
        processMessage(message) {
            if (!message) return '';
            message = this.$options.filters.striphtml(message);
            if (message.length > 120) {
                return message.substring(0, 120) + '...';
            }
            return message;
        },
        onChangePage(data) {
            let pageNum = typeof data === 'number'
                ? data
                : parseInt(new URL(data).searchParams.get('page')) || 1;

            const currentPage = parseInt(this.$route.query.page) || 1;
            if (pageNum !== currentPage) {
                this.$router.push({
                    name: this.$route.name,
                    params: this.$route.params,
                    query: { page: pageNum }
                });
            }
            sessionStorage.setItem('globalAlertLastPage', pageNum);

            this.fetchAlerts(pageNum).then(() => {
                this.$nextTick(() => {
                    const el = document.getElementById('content') || document.documentElement;
                    el.scrollTo({ top: 0, behavior: 'smooth' });
                });
            });
        },
        createAlert() {
            this.pendingScrollAlertId = null;
            const currentRouteName = this.$route.name;
            const isAlreadyInDetail = ['globalAlertDetail', 'globalAlertStatus', 'globalAlertNew'].includes(currentRouteName);
            const routeConfig = {
                name: 'globalAlertNew',
                params: { alertId: 'new' }
            };
            
            if (isAlreadyInDetail) {
                this.$router.replace(routeConfig);
            } else {
                this.$router.push(routeConfig);
            }
        },
        deleteAlert(alertId) {
            this.$store.dispatch('deleteAlert', { alertId });
        },
        setAlert(alert) {
            this.pendingScrollAlertId = alert.id;
            const slug = alert.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
            const currentRouteName = this.$route.name;
            const isAlreadyInDetail = ['globalAlertDetail', 'globalAlertStatus', 'globalAlertNew'].includes(currentRouteName);
            const currentPage = parseInt(this.$route.query.page) || 1;
            sessionStorage.setItem('globalAlertLastPage', currentPage);
            
            const routeConfig = {
                name: 'globalAlertDetail',
                params: { alertId: alert.id, slug: slug }
            };
            
            if (isAlreadyInDetail) {
                this.$router.replace(routeConfig);
            } else {
                this.$router.push(routeConfig);
            }
        },
        showStatusDetail(alert) {
            this.pendingScrollAlertId = alert.id;
            const slug = alert.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
            const currentRouteName = this.$route.name;
            const isAlreadyInDetail = ['globalAlertDetail', 'globalAlertStatus', 'globalAlertNew'].includes(currentRouteName);
            const currentPage = parseInt(this.$route.query.page) || 1;
            sessionStorage.setItem('globalAlertLastPage', currentPage);
            
            const routeConfig = {
                name: 'globalAlertStatus',
                params: { alertId: alert.id, slug: slug }
            };
            
            if (isAlreadyInDetail) {
                this.$router.replace(routeConfig);
            } else {
                this.$router.push(routeConfig);
            }
        },
        async loadAndShowAlert(alertId, routeName) {
            try {
                const response = await this.$store.dispatch('fetchAlertById', alertId);
                if (response.success) {
                    const alert = response.alert;
                    if (routeName === 'globalAlertDetail') {
                        this.alertTitle = alert.title;
                        this.alertDetail = alert.message;
                        this.alertSender = alert.sender;
                        this.alertTime = alert.created_at;
                        document.title = `${alert.title} (${alert.id})`;
                        this.$bvModal.show('globalAlertDetail1');
                    } else if (routeName === 'globalAlertStatus') {
                        this.alertStatusDetail = response.statusesDetail || [];
                        document.title = `Alert Status: ${alert.title} (${alert.id})`;
                        this.$bvModal.show('alertStatusDetail');
                    }
                }
            } catch (error) {
                console.error('Failed to load alert:', error);
            }
        },
        handleRouteParams() {
            const routeName = this.$route.name;
            const alertId = this.$route.params.alertId;

            if (routeName === 'globalAlertNew' && alertId) {
                this.$bvModal.show('createGlobalAlert');
            } else if (routeName === 'globalAlertDetail' && alertId) {
                this.showAlertDetailModal(alertId);
            } else if (routeName === 'globalAlertStatus' && alertId) {
                this.showAlertStatusModal(alertId);
            }
        },
        showAlertDetailModal(alertId) {
            const alert = this.allAlerts.data?.find(a => a.id == alertId);
            if (alert) {
                this.alertTitle = alert.title;
                this.alertDetail = alert.message;
                this.alertSender = alert.sender;
                this.alertTime = alert.created_at;
                document.title = `${alert.title} (#${alert.id})`;
                this.$bvModal.show('globalAlertDetail1');
            }
        },
        showStatusDetail(alert) {
            this.alertStatusDetail = this.allAlerts.statusesDetail[alert.id];
            this.$bvModal.show('alertStatusDetail');
        },
        showAlertStatusModal(alertId) {
            const alert = this.allAlerts.data?.find(a => a.id == alertId);
            if (alert && this.allAlerts.statusesDetail) {
                this.alertStatusDetail = this.allAlerts.statusesDetail[alert.id] || [];
                document.title = `Alert Status: ${alert.title} (#${alert.id})`;
                
                this.$bvModal.show('alertStatusDetail');
            }
        },
        closeAlertDetail() {
            const currentRoute = this.$route.name;
            const isDetailRoute = ['globalAlertDetail', 'globalAlertStatus', 'globalAlertNew'].includes(currentRoute);
            if (isDetailRoute) {
                if (this.openedDirectlyWithModal) {
                    this.openedDirectlyWithModal = false;
                    const lastPage = parseInt(sessionStorage.getItem('globalAlertLastPage')) || 1;
                    this.$router.push({ name: 'globalAlert', query: { page: lastPage } });
                } else {
                    this.$router.back();
                }
            }
        },
        scrollToAlertCenter(alertId) {
            if (!alertId) return;
            this.$nextTick(() => {
                const el = document.getElementById(`alert-row-${alertId}`);
                if (!el) return;
                el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
        },

        getLocalAlertTime(time) {
            const alertTime = this.$moment.utc(time);
            alertTime.local();
            return alertTime.format('MMM Do, hh:mm a');
        }
    },
    watch: {
        '$route'(to, from) {
            const wasDetail = ['globalAlertDetail', 'globalAlertStatus', 'globalAlertNew'].includes(from.name);
            const isList = to.name === 'globalAlert';
            if (isList && wasDetail) {
                this.$bvModal.hide('globalAlertDetail1');
                this.$bvModal.hide('alertStatusDetail');
                this.$bvModal.hide('createGlobalAlert');
                this.$nextTick(() => {
                    this.scrollToAlertCenter(this.pendingScrollAlertId);
                    this.pendingScrollAlertId = null;
                });
            }
            if (to.name && to.name.startsWith('globalAlert')) {
                if (to.name === 'globalAlert' && to.query.page !== from.query.page) {
                    const pageFromUrl = parseInt(to.query.page) || 1;
                    sessionStorage.setItem('globalAlertLastPage', pageFromUrl);
                    this.fetchAlerts(pageFromUrl);
                    document.title = `Global Alert - Page ${pageFromUrl}`;
                }
                if (to.name !== 'globalAlert') {
                    this.handleRouteParams();
                }
            }
        },
        allAlerts: {
            handler(newVal) {
            },
            deep: true
        }
    }
}
</script>

<style>

</style>
